var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrap"},[_c('HeaderSider'),_c('a-layout',{staticStyle:{"background":"#262626"}},[_c('LeftSider'),_c('a-layout',[_c('a-layout-content',{staticClass:"app-content"},[_c('Breadcrumbs'),_c('ContentSider')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }